export const aircraftMarkerColors = {
  default: '#BAD928',
  blue: '#297CD7',
  green: '#BAD928',
  yellow: '#EABB29',
  orange: '#F55C21',
  red: '#BA2321'
};
